// extracted by mini-css-extract-plugin
export default {"item":"ErrorMessage_item__f8QgG","btn":"ErrorMessage_btn__y5gjM","btns":"ErrorMessage_btns__9B2La"};